<div class="modal-header d-flex align-items-center justify-content-between gap-1">
  <h2 class="mb-0">Description</h2>
  <lucide-icon name="x" [mat-dialog-close]="description" size="16" color="black"></lucide-icon>
</div>
<div class="modal-body">
    <!-- <angular-editor id="description" [(ngModel)]="description">
    </angular-editor> -->
    <div class="col-lg-12">
      <div class="form-group">
        <mat-form-field class="textarea_field w-100">
          <textarea matInput (keyup)="autoGrow()" #textArea [(ngModel)]="description" name="desc" #desc="ngModel" required="true">
          </textarea>
        </mat-form-field>
      </div>
    </div>
</div>
<div class="text-right modal-footer">
  <button class="btn btn-sm" (click)="onNoClick()">Cancel</button>
  <button class="btn btn-sm" [mat-dialog-close]="description" cdkFocusInitial>Ok</button>
</div>

